<template>
  <div class="notice">
    <div>
      <span class="back" @click="routerTo('/pcpage/skill/skilllist')">
        <img src="../img/arrow.png" alt="" /> 摄影技巧
      </span>
    </div>
    <div class="content">
      <div class="title">图片拍摄技巧</div>
      <div class="word">
        <div>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >摄影小贴士</span
              ></strong
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              >接触相机之后，一般人往往都会对其构造和拍出的照片抱有种种疑问和兴趣。在这里我们将会介绍比入门稍难一些的内容，同时挑战针对不同场景的基础拍摄，从实践中体验使用数码单反相机的乐趣。</span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630912347998483.png"
              title="20210906-1630912347998483.png"
              alt="wps121.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p style="margin-top: 17px;margin-bottom: 17px;line-height: 23px">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >摄影基础知识：</span
              ></strong
            >
          </p>
          <p style="margin-top: 17px;margin-bottom: 17px;line-height: 23px">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >数据记录原理：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >数据记录流程为：图像感应器</span
              ><span style="font-family:微软雅黑"
                >→影像处理器→存储卡。到影像处理器为止的阶段用于完成成像，存储卡仅起到储存数据的作用。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >记录画质：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >所谓的画质，是指影像处理器所生成图像数据的大小和质量。对图像感应器传送来的数据，按照指定形式进行加工，获得符合使用需求的质量。</span
              ></span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630912372823949.png"
              title="20210906-1630912372823949.png"
              alt="wps122.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p>
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >光圈：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >光圈英文名称为</span
              ><span style="font-family:微软雅黑"
                >Aperture，光圈是一个用来控制光线透过镜头，进入机身内感光面的光量的装置。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >完整的光圈值系列如下：</span
              >
              <span style="font-family:微软雅黑"
                >F1，F1.2， F1.4， F2， F2.8， F4， F5.6， F8， F11， F16，
                F22， F32， F44， F64。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >光圈作用：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >光圈是控制光线进入相机多少的部件，光圈值是光线数量值。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >他们和照片的关系，第一和照片的明暗有关，第二和照片的色彩有关。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >快门速度越慢，进入相机的光线就多，照片就会很亮，反之就会很暗。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >光圈越大，进入的相机的光线就多，照片就会很亮，反之就会很暗。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >光圈越大，景深就越小，也就背景越模糊，光圈越小，景深越大，背景就越清楚。（注解：光圈和相机上的光圈数量标示相反，数越大光圈越小，数越小光圈越大。）</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >大光圈：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >1，用大光圈镜头在取景器里看景物会亮很多。</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >2，适应光线的范围广，在光线不好的时候，也能拍出好的作品。</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >3，更能够提高快门速度，可以更好的凝结动态物体。</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >4，更好的虚化背景，突出主体。</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >小光圈：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >一、小光圈可以获得更大的景深（需要被摄物前后都清楚的时候，比如合影）；</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >二、小光圈可以获得更好的成像品质（因为成像时只是使用了镜头镜片的中心部分）；</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >三、小光圈可以获得更慢的快门速度（当你因创作需要较慢的快门速度的，比如将水流拍成拉丝状）。</span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >快门：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >快门是镜头前阻挡光线进来的装置，是一种让光线在一段时间里照射胶片的装置。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >高速快门：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >高速快门拍摄的照片富有活力，可以凝固被摄物体。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >慢速快门：</span
              ></strong
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >慢速快门能记录轨迹，拍夜景的时候经常用慢速快门记录汽车的轨迹，特别好看，还有就是记录一些流水的轨迹，不过白天拍流水非常困难。</span
              ></span
            >
          </p>
          <p>
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >曝光：</span
              ></strong
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;text-indent: 32px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >除光质和光向，还有光的量，这本来靠快门和光圈调节就能完全掌握，有甚么大不了呢</span
              ><span style="font-family:微软雅黑"
                >?控制准确曝光当然不难，何况现今相机的测光系统已很先进，加上数码相机可以拍摄后实时重看，要调整合适光量一点不难。</span
              ></span
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >但曝光的控制其实一样可以左右照片出来的效果，明与暗有时要切合气氛，适当控制曝光，可让影像出现戏剧性的变化。而就算是同一曝光度，快门也可以有快有慢，快的快门凝结高速，但慢的快门可以将动态展现，这就是光量以外，曝光可做的大事情，能控制曝光得宜，才称得上是懂摄影。</span
            >
          </p>
          <p>
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >色彩：</span
              ></strong
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;text-indent: 32px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >对颜色敏感是人与生俱来的能力，视力正常的人也会对色彩敏感，但摄影人尤甚，别以为拍黑白就不用理，其实黑白的灰调一样受着现实颜色所影响，最有趣和最玄妙的事情是，色就是光，不同波长的光产生不同的颜色，因为对象反射不同的光波，也形成不同的颜色出现，光也是色</span
              ><span style="font-family:微软雅黑">!</span></span
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >若单纯说拍一张吸引人的影像，如风景，其实色彩大可尽情奔放，拍摄时或后期用高一点饱和度是无妨的，就算是早年间也有人特别用幻灯片来拍，以求更浓的色彩。而色彩也一样可以改变影像的气氛，蓝一点的予人冷的感觉，黄一点、红一点可予人暖的感觉，所以摄影师能否把影像经营得好，很大程度也看他如何处理色彩</span
              ><span style="font-family:微软雅黑">!</span></span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >饱和度：</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >风景影像用更高的饱和度已不是什么秘技，数码可拍摄后再增饱和度，大家习惯见到的风景照，无不是经过处理吧。</span
            >
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;text-indent:32px;text-align:center;line-height:23px"
          >
            <img
              src="../img/skill/20210906-1630912386918298.png"
              title="20210906-1630912386918298.png"
              alt="wps123.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                ><span style="font-family:微软雅黑">构图：</span>
              </span></strong
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;text-indent: 32px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              >构图是摄影的基本功，不能不学，但也有一些摄影派别不太拘泥于构图，但那只是更随意的拍摄风格，不能说完全没构图，好看的影像定会发现它们有构图的痕迹。</span
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >有些摄影人日子有功，构图都没那么着迹，他们自然会为影像构图，其实这也是绘画艺术的基础，图不构不成，否则美观性会成疑问。同样地，要仔细讲构图，无论中外定会基于</span
              ><span style="font-family:微软雅黑"
                >1/3构图作为入门，其实那是从黄金分割(Golden
                Section)演变出来的构图技法，简单说就是把画面的长和宽各分三等份，就画成一个井字，只要把主体置于那些相交点，又或者将画面分成三分之一、三分之二来处理，那便令影像自然地多了一些“重量”，处理得宜也引导观者去到你想强调的部份。当然还有各种利用几何、线条、形状、重复甚至光暗、色彩等的构图技法。</span
              ></span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >主体：</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >影像其实就和我们的语言一样，有着传播信息的作用，如果</span
              ><span style="font-family:微软雅黑"
                >“写”的时候不加注意，甚至乱来，不把重要的东西安放在重要的位置，又或者有过多混乱的信息，就会使人“读”起来吃力，甚至不能理解，那当然令影像失去观看的价值了。</span
              ></span
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >对初学者，一般都会劝吁他们，就算以上光、曝光、色彩、瞬间、构图甚么都不理，也要找个主体来拍，拍一个人就好好的拍一个人，拍一杯水就拍一杯水，千万不要 </span
              ><span style="font-family:微软雅黑"
                >“Don't Think Just Shoot”!</span
              ></span
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p style="margin-left: 0">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >人像摄影构图技巧</span
              ></strong
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                ><span style="font-family:微软雅黑">场景</span
                ><span style="font-family:微软雅黑"
                  >1：使背景美丽虚化的人像摄影常用技巧</span
                ></span
              ></strong
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >1选择明亮的部分作为背景，并进行大幅虚化</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >选择光线能够照到的较为明亮的部分作为背景，这样可以避免画面给人以沉重的印象。需要注意的是常绿树的色彩较浓，即使被虚化了看起来颜色也不会太美丽。被拍摄者的背景并不一定要是植物，也可以选择色彩鲜艳的墙壁。</span
              ></span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >2利用逆光让头发产生高光效果</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >在让被拍摄者站位的时候位置必须精心揣摩，选择合适的位置，使头发出现高光，看上去很闪亮。头发一旦显得有光泽，被拍摄者的表情也会给观者以特别的印象。如果头发看起来很黑，画面整体就会显得较暗，所以拍摄者需要有意识地加入高光。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >3使用反光板让较暗的脸部变得明亮</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >有效使用反光板可以让逆光造成的昏暗脸部变得明亮起来，让皮肤富有质感。在拍摄人像时，原则上应当使用逆光或者侧光，而不适合用会让脸部出现明显阴影的顺光。所以在室外拍摄人像时反光板是必须携带的拍摄工具。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >4在构图时可以将手臂裁剪掉</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >有时被拍摄者的姿势会让其肩部或者手腕部分处于构图范围之外，这完全不会有问题。反而能让画面产生变化，给人以大胆的感觉，所以不要犹豫继续拍。如果勉强将被拍摄者的全部都收入画面，照片反而会显得平庸。试着大胆地构图吧。</span
            >
          </p>
          <p style="text-indent:32px;text-align:center;line-height:23px">
            <img
              src="../img/skill/20210906-1630912399980557.png"
              title="20210906-1630912399980557.png"
              alt="wps124.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                ><span style="font-family:微软雅黑">场景</span
                ><span style="font-family:微软雅黑"
                  >2：将背景和被拍摄者巧妙融合的广角人像</span
                ></span
              ></strong
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >1展现出空间的宽阔感</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >照片的视角很宽，连天顶也被收入画面。使用广角镜头拍摄时会将预想不到的部分也收入画面，所以必须对构图进行认真整理。拍摄者应该意识到相机的取景器视野率来进行构图，并考虑如何灵活运用空间。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >2灵活运用画面四周的变形</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >广角镜头拍摄出的画面四周尤其富有透感，有意识地运用这一特性进行拍摄将会非常有趣。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >3大胆享受透感</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >在画面中灵活运用这样的透感，能让整个构图看起来非常新颖。在使用广角镜头时，大胆变换拍摄角度可以带来独特的视觉效果。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >4不要使用对焦锁定功能合焦</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >在使用广角镜头从下向上拍摄时应该避免使用中央对焦点＋对焦锁定的方式来对焦。因为与合焦的被拍摄者距离过近，所以容易产生被称为余弦误差的失焦现象。应当预先选定对焦点，避免使用对焦锁定带来的相机移动，这样才能精确合焦。</span
            >
          </p>
          <p style="text-indent:32px;text-align:center;line-height:23px">
            <img
              src="../img/skill/20210906-1630912412355438.png"
              title="20210906-1630912412355438.png"
              alt="wps125.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                ><span style="font-family:微软雅黑">场景</span
                ><span style="font-family:微软雅黑"
                  >3：使用超远摄镜头拍摄全身街景人像</span
                ></span
              ></strong
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >1尽量虚化背景</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >超远摄镜头能够在为被拍摄者拍摄全身人像时大幅虚化背景。如果只是拍摄脸部特写和胸部以上的人像，那么使用短焦距镜头在光圈全开时也能获得背景较为虚化的照片。但是拍摄全身人像时，虚化背景需要使用焦距在</span
              ><span style="font-family:微软雅黑"
                >300mm以上。2考虑与背景色的平衡</span
              ></span
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >应尽可能让被拍摄者的头部位于背景颜色明亮的部分，这样被拍摄者的头发就不会和背景混在一起。需要注意的是，如果背景有引人注目的花纹或是重复的图案，会让被拍摄者本身失去关注度，而背景喧宾夺主。拍摄者还需要确认被拍摄者脸部周围有无暗色部分或者看上去令人生厌的广告牌等，然后决定被拍摄者所处位置。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >2被拍摄者的眼部应当有眼神光</span
              ></strong
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;text-indent: 32px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              >即使在整个构图中被拍摄者看起来较小，也应当保证脸部有光线照亮。特别是要确保其眼部有较为明显的反光（眼神光）。如果眼部没有反光，就会显得眼部暗淡无神，很难明白被拍摄者的脸部表情。拍摄全身人像和拍摄人物特写时一样，眼神光很重要。</span
            >
          </p>
          <p style="margin-top: 17px;margin-bottom: 17px;line-height: 23px">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >3不将背景全部虚化，体现出一定的透感</span
              ></strong
            >
          </p>
          <p>
            <span style="font-family: 微软雅黑;font-size: 16px"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:微软雅黑"
                >将背景全部虚化后很难体现出透感。全身人像拍摄的要点之一就是通过控制虚化部分和未被虚化的部分来巧妙展现出被拍摄者和背景之间的透感。</span
              ></span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630912427458108.png"
              title="20210906-1630912427458108.png"
              alt="wps126.png"
            /><span style="font-family: 微软雅黑;font-size: 18px">&nbsp;</span>
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                ><span style="font-family:微软雅黑">场景</span
                ><span style="font-family:微软雅黑"
                  >4：能反映被拍摄者内心世界的暗调人像</span
                ></span
              ></strong
            >
          </p>
          <p style="margin-top: 17px;margin-bottom: 17px;line-height: 23px">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >1必须让眼部和唇部有高光</span
              ></strong
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;text-indent: 32px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              >当整张人像照片呈暗调时，最好在吸引视觉注意的部分加入光。通过加入高光，曝光可以更暗，让照片显得有冲击力。拍摄暗调人像的关键不是单纯的减少曝光。</span
            >
          </p>
          <p style="margin-top: 17px;margin-bottom: 17px;line-height: 23px">
            <strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >2考虑与背景光线的平衡</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;">
            <span style="font-family: 微软雅黑;font-size: 16px;"
              ><span style="font-family:微软雅黑"
                >如果从被拍摄者的背景（背后）有强烈光线射入，那么画面整体就会显得比较锐利，成为一张鲜明的照片。普通背景的话，照片只会看起来较暗，但是如果背景有强光，那么被拍摄者脸部的暗淡就会显得很自然，照片的暗调就会被强调出来。</span
              ></span
            ><span style="font-family: 微软雅黑;font-size: 16px"><br /></span
            ><strong
              ><span style="font-family: 微软雅黑;font-size: 16px"
                >3被拍摄者表情最好是冷酷且有野性美</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;">
            <span style="font-family: 微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >暗调的人像照片给人的整体感觉应该是比较酷的。所以被拍摄者脸上不应该带着笑容。最好通过让人有些吃惊的冷酷表情，来赋予照片特色。被拍摄者的姿势必须和表情搭调，不要太有活力。总之拍摄照片时应该把握好整体的感觉。</span
              ></span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >4针对眼部进行精确对焦</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >人像摄影的基本原则之一就是对眼睛合焦。特别是在拍摄暗调照片时，眼神更是决定了整张照片的印象，所以必须精确合焦。要时刻注意合焦位置，拍摄后也不能松懈，要认真确认照片效果。</span
            >
          </p>
          <p style="text-indent:32px;text-align:center;line-height:23px">
            <img
              src="../img/skill/20210906-1630912440782056.png"
              title="20210906-1630912440782056.png"
              alt="wps127.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                ><span style="font-family:微软雅黑">场景</span
                ><span style="font-family:微软雅黑"
                  >5：黑白世界中的美</span
                ></span
              ></strong
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >1虚化背景让颗粒感更明显</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑">利用高</span
              ><span style="font-family:微软雅黑"
                >ISO感光度下产生的噪点，能让照片具有颗粒感。为了让这样的颗粒感更明显，可以通过选择合适的光圈和镜头来虚化背景。如果能够利用画面中间调部分的噪点，颗粒感的效果会更加明显，所以背景不应该过于昏暗。</span
              ></span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >2有必要时出现高光溢出也无妨</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >高光溢出一般来说是拍摄时需要避免的现象。但是在拍摄单色照片时，出现高光溢出反而能使照片更让人印象深刻。主被摄体整体出现高光溢出当然不好，但是一小部分出现这样的现象完全没有关系。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >3选择符合单色照片气氛的拍摄场所</span
              ></strong
            >
          </p>
          <p style="text-indent: 32px;line-height: 23px">
            <span
              style=";font-family:微软雅黑;font-size: 16px"
              >不是随便在什么地方拍摄单色照片都能有好效果，拍摄者应该选择那些能够渲染出单色照片风格气氛的场所。比起白天的室外，在稍微昏暗的室内拍摄，颗粒感会更加明显，更能够体现出单色照片的独特气氛。</span
            >
          </p>
          <p style="line-height: 23px">
            <strong
              ><span
                style=";font-family:微软雅黑;font-size: 16px"
                >4考虑被拍摄者服装的色彩搭配</span
              ></strong
            >
          </p>
          <p style="line-height: 23px;text-indent: 32px;">
            <span style="font-family: 微软雅黑;font-size: 16px"
              ><span style="font-family:微软雅黑"
                >拍摄单色风格会让照片的气氛和给人的印象大大改变。单色照片绝不仅仅是将所有物体拍摄成黑色和白色那么简单。拍摄单色照片时，有些色彩比较醒目。正式拍摄前应该进行试拍，有必要的话可以更换不同颜色的服装。如果拍摄者能够意识到不同颜色变成单色后的不同效果，那么拍摄单色照片的技术就会明显进步。</span
              ></span
            >
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;text-indent:32px;text-align:center;line-height:23px"
          >
            <img
              src="../img/skill/20210906-1630912455666363.png"
              title="20210906-1630912455666363.png"
              alt="wps128.png"
            /><span style="font-family: 微软雅黑;font-size: 16px">&nbsp;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notice",
  data: function() {
    return {};
  },
  methods: {
    routerTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
  width: 1200px;
  margin: 50px auto 50px;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .back {
    font-size: 24px;
    color: #0b0b0b;
    font-weight: bold;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-top: -4px;
    }
  }
  .content {
    width: 1200px;
    background-color: #fff;
    padding: 0 40px 70px;
    text-align: center;
    margin-top: 40px;
    box-sizing: border-box;
    .title {
      position: relative;
      top: -35px;
      width: 405px;
      height: 70px;
      line-height: 65px;
      margin: auto;
      background-image: linear-gradient(0deg, #746bef 0%, #728bf9 100%);
      border-radius: 35px;
      text-align: center;
      font-size: 50px;
      color: #fff;
      font-weight: bold;
      &:before {
        position: absolute;
        left: -60px;
        top: 15px;
        content: "";
        display: inline-block;
        width: 60px;
        height: 60px;
        background-image: url(../img/left.png);
        background-repeat: no-repeat;
      }
      &:after {
        position: absolute;
        right: -80px;
        top: 15px;
        content: "";
        display: inline-block;
        width: 60px;
        height: 60px;
        background-image: url(../img/right.png);
        background-repeat: no-repeat;
      }
    }
    p {
      text-align: left;
      font-size: 28px;
      color: #0b2ab0;
      line-height: 1.4;
    }
    .p_left {
      text-indent: 0;
    }
    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #0b2ab0;
      text-align: left;
      margin-top: 35px;
    }
    h3 {
      font-size: 28px;
      color: #0b2ab0;
      text-align: left;
      margin-top: 20px;
      text-indent: 1em;
    }
    .word {
      font-size: 16px;
      font-family: "Microsoft Yahei" !important;
      color: #666;
      line-height: 40px;
      strong {
        font-weight: bold;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 20px;
      }
      img {
        max-width: 554px !important;
      }
      p {
        line-height: 1.4;
        margin-bottom: 5px;
        color: #0b2ab0;
        word-break: break-all;
        span {
          font-size: 16px;
          font-family: "Microsoft Yahei";
        }
        a {
          color: #0b2ab0;
        }
        strong {
          font-weight: bold;
        }
        em {
          font-style: italic;
        }
        img {
          max-width: 554px !important;
          text-indent: 0;
          margin-bottom: 0px;
        }
        video {
          margin-left: -2em;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
